export default __webpack_public_path__ + "static/media/sales.f63166d1.svg";